import React from 'react';
import {Directionality, IapRelationshipDetails} from '../../../backend/model';
import {compareNumericString} from '../../../utils/sorting';
import {IapLink} from '../../TableItemLink';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';
import Icon from "@amzn/awsui-components-react/polaris/icon";

const TABLE_ID = 'iapPage-iapRelationshipsTable'

const COLUMN_DEFINITIONS = (iapId: string, fnsku?: string) => [
    {
        id: 'directionality',
        header: <div data-tip={DirectionalityDescription(iapId)}>Dir. <Icon name={'support'} /></div>,
        cell: (iap: IapRelationshipDetails): JSX.Element => <span style={{fontSize: '20px'}}>
            { getDirectionalityIcon(iap.directionality as Directionality) }
        </span>,
        sortingField: 'directionality',
    },
    {
        id: 'secondIapId',
        header: 'IAP',
        cell: (iap: IapRelationshipDetails): JSX.Element => <IapLink iapId={iap.secondIapId} fnsku={fnsku}/>,
        sortingComparator: (a: IapRelationshipDetails, b: IapRelationshipDetails): number =>
            compareNumericString(a.secondIapId, b.secondIapId),
        sortingField: 'secondIapId'
    },
    {
        id: 'secondIapName',
        header: 'Name',
        cell: (iap: IapRelationshipDetails): string => iap.secondIapName,
        sortingField: 'secondIapName',
    },
]

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'Dir.',
        key: 'directionality',
        groupValuesLabel: 'IAP directionality values',
        operators: operators,
    },
    {
        propertyLabel: 'IAP',
        key: 'secondIapId',
        groupValuesLabel: 'IAP ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Name',
        key: 'secondIapName',
        groupValuesLabel: 'IAP name values',
        operators: operators,
    },
]

const IapRelationshipTable: React.FC<TableInput> = ({tableItems, additionalValue, fileName}) => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: `Overlaps with ${tableItems.length} IAPs`,
        fileName: fileName,
        getRow: function (row: any): string[] {
            return [row.directionality, row.secondIapId, row.secondIapName]
        }
    }
    return useTableCreation(
        tableDetails,
        COLUMN_DEFINITIONS(additionalValue.iapId, additionalValue.fnsku),
        tableItems,
        FILTERING_PROPERTIES,
        1
    )
}

const DirectionalityDescription = (iapId: string) => {
    return `
⇄ IAP ${iapId} and the overlapping IAP supply inventory to each other<br/>
← The overlapping IAP supplies inventory to IAP ${iapId}<br/>
→ IAP ${iapId} supplies inventory to the overlapping IAP
`
}

const getDirectionalityIcon = (directionality: Directionality) => {
    switch (directionality) {
        case Directionality.TWO_WAY:
            return '⇄'
        case Directionality.ONE_WAY_FIRST_IAP_CONSUMING_FROM_SECOND:
            return '←'
        case Directionality.ONE_WAY_SECOND_IAP_CONSUMING_FROM_FIRST:
            return '→'
    }
}

export default IapRelationshipTable
